import { render, staticRenderFns } from "./QuerySql.vue?vue&type=template&id=1360574c&scoped=true"
import script from "./QuerySql.vue?vue&type=script&lang=js"
export * from "./QuerySql.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=1360574c&prod&scoped=true&lang=css&external"
import style1 from "./QuerySql.vue?vue&type=style&index=1&id=1360574c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360574c",
  null
  
)

export default component.exports